// extracted by mini-css-extract-plugin
export default {"audio-player":"AudioPlayer_audio-player__YKOO5","hidden":"AudioPlayer_hidden__UP0DY"};